import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private currentTheme: 'viva-light' | 'viva-dark' = 'viva-light';

  constructor() {
    const saved = localStorage.getItem('theme') as 'viva-light' | 'viva-dark' | null;
    this.loadTheme(saved || 'viva-light');
  }

  loadTheme(theme: 'viva-light' | 'viva-dark'): void {
    const linkId = 'app-theme';
    let link = document.getElementById(linkId) as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement('link');
      link.id = linkId;
      link.rel = 'stylesheet';
      document.head.appendChild(link);
    }
    // Angular bundles the themes as viva-light.css / viva-dark.css at the root
    link.href = `${theme}.css`;
    this.currentTheme = theme;
    document.body.className = theme;
    localStorage.setItem('theme', theme);
  }

  toggleTheme(): void {
    this.loadTheme(this.currentTheme === 'viva-light' ? 'viva-dark' : 'viva-light');
  }

  getCurrentTheme(): string {
    return this.currentTheme;
  }
}
